// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountSaveModel {
    static getAttributeTypeMap() {
        return AccountSaveModel.attributeTypeMap;
    }
}
AccountSaveModel.discriminator = undefined;
AccountSaveModel.attributeTypeMap = [
    {
        "name": "accountType",
        "baseName": "accountType",
        "type": "AccountType"
    },
    {
        "name": "accountStatus",
        "baseName": "accountStatus",
        "type": "AccountStatus"
    },
    {
        "name": "partyId",
        "baseName": "partyId",
        "type": "number"
    },
    {
        "name": "securePartyId",
        "baseName": "securePartyId",
        "type": "string"
    },
    {
        "name": "assignedUser",
        "baseName": "assignedUser",
        "type": "number"
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": "Array<AccountPayorRelationModel>"
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": "Array<AccountRelationModel>"
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": "Array<AccountRelationModel>"
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": "Array<AccountRelationModel>"
    },
    {
        "name": "documents",
        "baseName": "documents",
        "type": "Array<AccountDocumentRelationshipModel>"
    },
    {
        "name": "notes",
        "baseName": "notes",
        "type": "Array<number>"
    },
    {
        "name": "tasks",
        "baseName": "tasks",
        "type": "Array<number>"
    },
    {
        "name": "voicemailOptInStatus",
        "baseName": "voicemailOptInStatus",
        "type": "Array<AccountVoicemailOptInModel>"
    },
    {
        "name": "assignmentOfBenefitFlag",
        "baseName": "assignmentOfBenefitFlag",
        "type": "boolean"
    },
    {
        "name": "isIneligibleForMailInClaims",
        "baseName": "isIneligibleForMailInClaims",
        "type": "boolean"
    },
    {
        "name": "allowAutoReenroll",
        "baseName": "allowAutoReenroll",
        "type": "boolean"
    }
];
//# sourceMappingURL=accountSaveModel.js.map